import { Event } from '../models/event.model';

export function isEventLocked(event: Event): boolean {
  if (!event?.startTime) {
    return false;
  }

  const startTime =
    event.startTime instanceof Date
      ? event.startTime.getTime()
      : new Date(event.startTime).getTime();

  const now = new Date().getTime();

  return startTime <= now;
}
